import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
	theme => ({
		text: {
			marginBottom: theme.spacing(5),

			[theme.breakpoints.down('md')]: {
				'& *': {
					textAlign: ({ metaData }) => {
						const mobileAlignment = metaData.mobileAlignment?.metaValue

						return mobileAlignment ? `${mobileAlignment} !important` : null
					},
				},
			},
		},
		editableContainer: {
			marginBottom: theme.spacing(5),
		},
	}),
	{ name: 'Content-Content4' },
)

export default useStyles
